import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { styled } from '@linaria/react';
import { Pocket, useWaffles } from '@pelotoncycle/waffles';
import React from 'react';
import { useTrackViewedDeclineAgeConfirmation } from '@webtv/analytics';
import { MediumButton } from '@webtv/buttons';
import { Copy } from '@webtv/copy-provider';
import { DeclineButton } from './DeclineButton';
import { Header, Subheader } from './shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DeclineConfirmationModal = function DeclineConfirmationModal(_ref) {
  var handleCancel = _ref.handleCancel,
      handleConfirm = _ref.handleConfirm,
      errorsEncountered = _ref.errorsEncountered;

  var _useWaffles = useWaffles(),
      createFocusTrap = _useWaffles.createFocusTrap;

  var _useTrackViewedDeclin = useTrackViewedDeclineAgeConfirmation(),
      _useTrackViewedDeclin2 = _slicedToArray(_useTrackViewedDeclin, 2),
      trackViewedDeclineAgeConfirmation = _useTrackViewedDeclin2[0],
      pending = _useTrackViewedDeclin2[1];

  React.useEffect(function () {
    // Only track once needed info is loaded
    if (!pending) {
      trackViewedDeclineAgeConfirmation(errorsEncountered.length, errorsEncountered);
    } // This should only run once for this page
    // `track` intentionally ommitted to avoid additional runs in the event that useTrack is updated
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [pending]);
  var focusRoot = React.useRef();
  var goBackRef = React.useRef();
  var goBackFocusRef = React.useRef();
  var declineFocusRef = React.useRef();
  React.useEffect(function () {
    if (focusRoot.current) {
      var _goBackRef$current;

      createFocusTrap(focusRoot.current, (_goBackRef$current = goBackRef.current) !== null && _goBackRef$current !== void 0 ? _goBackRef$current : undefined);
    }
  }, [createFocusTrap]);
  return /*#__PURE__*/_jsxs(Container, {
    "data-test-id": "declineConfirmationModal",
    children: [/*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsx(Copy, {
        id: "ageGate.declineConfirmation"
      })
    }), /*#__PURE__*/_jsx(Subheader, {
      children: /*#__PURE__*/_jsx(Copy, {
        id: "ageGate.declineDetails"
      })
    }), /*#__PURE__*/_jsxs(Pocket, {
      id: "declineMain",
      vertical: true,
      position: 3,
      ref: focusRoot,
      children: [/*#__PURE__*/_jsx(Pocket, {
        id: "goBack",
        position: 0,
        ref: goBackRef,
        focusRef: goBackFocusRef,
        children: /*#__PURE__*/_jsx(GoBack, {
          dataTestId: "goBackButton",
          handleClick: handleCancel,
          focusRef: goBackFocusRef,
          children: /*#__PURE__*/_jsx(Copy, {
            id: "ageGate.goBack"
          })
        })
      }), /*#__PURE__*/_jsx(Pocket, {
        id: "decline",
        position: 1,
        focusRef: declineFocusRef,
        children: /*#__PURE__*/_jsx(DeclineButton, {
          dataTestId: "declineConfirmationButton",
          focusRef: declineFocusRef,
          handleClick: handleConfirm
        })
      })]
    })]
  });
};
var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1b0nyni"
});
var GoBack = /*#__PURE__*/styled(MediumButton)({
  name: "GoBack",
  class: "g1vv9yzt"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/age-gate/DeclineConfirmationModal.linaria.module.css");